<template>
  <div :class="['e-circular', 'e-circular-history-summary']">
    <TMSHeader
      :title="title"
      :needRightTop="true"
      :buttons="[]"
      :status="currentHistory.status"
    >
      <template slot="right-top">
        <div class="counter">
          <span class="counter__number"> {{ organizationsNumber }} </span>
          <span class="counter__label">{{ $t('eCircular.organizations') }}</span>
          <span class="counter__number"> {{ currentHistory.sentTotal }} </span>
          <span class="counter__label">{{ $t('eCircular.recipients') }}</span>
        </div>
      </template>
    </TMSHeader>
    <div class="main-content">
      <div class="history-content">
        <div
          class="total-count"
          v-if="totalResult"
        >
          <span>{{ $t('total') }}: {{ filterTotalResult }} / {{ totalResult }}</span>
        </div>
        <div class="search-results">
          <CommonTable
            :tableContentLists="orderedItems"
            :renderHeaderList="eCircularHistoryTableTitle"
            :getDisplayListLength="getDisplayListLength"
            :interactionFunc="interactionFunc"
            defaultOrderKey="type"
            :defaultOrder="false"
            :needFilter="true"
            :minWidth1800px="false"
            tableId="e-circular-history-summary"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as lodash from 'lodash'
import { mapGetters, mapActions } from 'vuex'

import TMSHeader from '@/controls/TMSHeader'
import CommonTable from '@/controls/CommonTable'

import dateUtil from '@/utils/dateUtil'
import navigation from '@/utils/navigation'
import { E_CIRCULAR_TYPES, RECIPIENT_TYPES } from './consts'

export default {
  name: 'ECircularHistorySummary',
  components: {
    TMSHeader,
    CommonTable,
  },
  data () {
    const interactionFunc = {
      tradeName: this.navToTRContacts,
      companyName: this.navToVendorDetail,
    }
    return {
      interactionFunc,
      ecircularId: this.$route.params.id,
      filterTotalResult: 0,
      historyId: this.$route.params.hid,
      summaryList: [],
    }
  },
  async created () {
    if (lodash.isEmpty(this.currentHistory)) {
      await this.loadECircular(this.ecircularId)
    }
  },
  methods: {
    ...mapActions('ecircular', ['loadECircular']),
    getDisplayListLength (length) {
      this.filterTotalResult = length
    },
    navToTRContacts (history) {
      navigation.toPage('ccdTenancyView', {id: history.ownedBy, tabIndex: this.isTenantEcircular ? '1' : '4'})
    },
    navToVendorDetail (history) {
      navigation.toPage('vendor-detail', {id: history.ownedBy})
    },
    resizeTable () {
      $('.e-circular-history-summary .common-table-content-container').css('width', $('.e-circular-history-summary .common-table-header-container tr').width() + 2)
    },
  },
  computed: {
    ...mapGetters('ecircular', ['currentECircular']),
    title () {
      let date = this.$t('emptyValue')
      if (this.currentHistory && this.currentHistory.updatedAt) {
        date = dateUtil.formatDate((this.currentHistory.updatedAt || ''), true)
      }
      return `${this.currentECircular.subject || this.$t('emptyValue')} - ${date}`
    },
    totalResult () {
      return this.summaryList.length
    },
    currentHistory () {
      return lodash.find(this.currentECircular.histories, {id: this.historyId}) || {}
    },
    organizationsNumber () {
      if (this.currentHistory && lodash.isArray(this.currentHistory.recipientTrees)) {
        return this.currentHistory.recipientTrees.length
      }
      return 0
    },
    isTenantEcircular () {
      return this.currentECircular.type === E_CIRCULAR_TYPES.TENANT
    },
    isVendorEcircular () {
      return this.currentECircular.type === E_CIRCULAR_TYPES.VENDOR
    },
    eCircularHistoryTableTitle () {
      return [
        {
          title: this.$t('eCircular.Bcc'),
          inputType: 'select',
          name: 'type',
          options: [
            'Bcc',
            'ALL',
            'System',
          ],
          customLabel: option => this.$t(`eCircular.${option}`),
          formatRule: option => this.$te(`eCircular.${option}`) ? this.$t(`eCircular.${option}`) : '',
        },
        {
          title: this.isVendorEcircular ? this.$t('eCircular.companyName') : this.$t('eCircular.tradeName'),
          inputType: 'input',
          name: this.isVendorEcircular ? 'companyName' : 'tradeName',
        },
        {
          title: this.$t('user.name'),
          inputType: 'input',
          name: 'name',
        },
        {
          title: this.$t('eCircular.recipients'),
          inputType: 'input',
          name: 'email',
        },
        {
          title: this.$t('status.name'),
          inputType: 'select',
          name: 'status',
          options: ['All', 'Pending', 'Sent', 'Failed'],
          customLabel: option => this.$t(`status.${option.toLowerCase()}`),
          formatRule: option => this.$te(`status.${option.toLowerCase()}`) ? this.$t(`status.${option.toLowerCase()}`) : '',
        },
        {
          title: this.$t('eCircular.reason'),
          inputType: 'input',
          name: 'reason',
        },
      ]
    },
    orderedItems () {
      const standaloneRecipients = lodash.cloneDeep(this.currentHistory.standaloneRecipients)
      const recipientTrees = lodash.cloneDeep(this.currentHistory.recipientTrees)
      let list = []
      let parseData = (item) => {
        if (item.reason && typeof item.reason === 'string') {
          const localeKey = `eCircular.reasons.${item.reason.replace(/\s/g, '').toLowerCase()}`
          item.reason = this.$te(localeKey) ? this.$t(localeKey) : this.$options.filters['capitalize'](item.reason)
        } else {
          item.reason = this.$t('emptyValue')
        }
        item.status = this.$options.filters['capitalize'](item.status)
        item.tradeName = item.tradeName || this.$t('emptyValue')
        item.companyName = item.companyName || this.$t('emptyValue')
        if (item.type &&
        item.type.toLowerCase() === RECIPIENT_TYPES.TO.toLowerCase()
        ) {
          item.type = ''
        } else {
          item.type = this.$options.filters['capitalize'](item.type)
        }
        return item
      }
      if (standaloneRecipients) {
        list = standaloneRecipients.map(item => {
          item.tradeName = this.$t('emptyValue')
          return parseData(item)
        })
      }
      if (recipientTrees) {
        recipientTrees.forEach(recipientTree => {
          recipientTree.recipients.forEach(item => {
            item.allowLink = true
            list.push(parseData(item))
          })
        })
      }
      this.summaryList = list
      return this.summaryList
    },
  },
  mounted () {
    window.addEventListener('resize', this.resizeTable)
    this.resizeTable()
  },
}
</script>

<style lang='scss' scoped>
@import '~styles/e-circular/styles';
.e-circular-history-summary {
  .tms-header {
    padding-left: 15px;
    padding-right: 15px;
  }
  .search-results {
    margin: 0 -15px;
  }
  ::v-deep .e-circular-history-summary_common-table {
    height: calc(100vh - 308px);
    tr {
      display: block;
    }
    th {
      text-transform: none;
    }
    .search-filter-input {
      width: 100%;
    }
    .type,
    .status {
      width: 130px;
      min-width: 120px;
    }
    .name {
      width: 15%;
    }
    .reason {
      width: 10%;
    }
   .tradeName,
   .companyName {
      width: calc(45% - 260px)
    }
    .email {
      width: 30%;
    }
  }
  ::v-deep .table-list {
    .status {
      &.sent {
        color: #3ba04d;
      }
      &.failed {
        color: #f73347;
      }
    }
  }
}
</style>
